export default "__VITE_ASSET__K0fNT2yJ__"